// extracted by mini-css-extract-plugin
module.exports = {"spinner":"style_spinner__R9P8v","spin":"style_spin__21CSJ","-small":"style_-small__2LaI-"};